import Vue from 'vue'

/**
 * Les constructeurs, notion de toute la plateforme (ZEborne seul) : la liste, la fiche (avec ses chiffres firmware),
 * créer, régler, supprimer, l'historique, une gamme créée à la main. Fusionner et ranger les gammes : ProductLineRepository.
 */
class ManufacturerRepository {

  // → { manufacturers, unassigned, total }
  list() {
    return this.fetch({ url: '/api/manufacturers', method: 'get' })
  }

  // La fiche : alias, chiffres, firmwares, modèles annoncés, versions sans firmware, réglages
  get(manufacturerId) {
    return this.fetch({ url: `/api/manufacturers/${manufacturerId}`, method: 'get' })
  }

  // { id?, name, aliases, firmwareProtocol, diagnosticProtocol, modelRules } → { id }
  save(manufacturer) {
    const { id, ...body } = manufacturer
    return id
      ? this.fetch({ url: `/api/manufacturers/${id}`, method: 'put', data: body })
      : this.fetch({ url: '/api/manufacturers', method: 'post', data: body })
  }

  delete(manufacturerId) {
    return this.fetch({ url: `/api/manufacturers/${manufacturerId}`, method: 'delete' })
  }

  // Ce qui s'est passé sur lui et ses gammes : [{ occurredAt, action, actorName, targetType, targetName, before, after }]
  history(manufacturerId) {
    return this.fetch({ url: `/api/manufacturers/${manufacturerId}/history`, method: 'get' })
  }

  // Une gamme vide, où ranger ensuite des types → { id }
  createProductLine(manufacturerId, name) {
    return this.fetch({ url: `/api/manufacturers/${manufacturerId}/product-lines`, method: 'post', data: { name } })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new ManufacturerRepository()
